import { RoutesEnum } from '@/enums';

export function stripOAuthParamsFromSearch(search: string): string {
  const params = new URLSearchParams(search);
  params.delete('code');
  params.delete('state');
  const next = params.toString();
  return next ? `?${next}` : '';
}

export function buildReturnPathAfterAuth(pathname: string, search: string): string {
  return `${pathname}${stripOAuthParamsFromSearch(search)}`;
}

export function sanitizeInternalReturnPath(
  raw: unknown,
  fallback: string = RoutesEnum.GET_STARTED
): string {
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//')) {
    return fallback;
  }
  if (raw.includes(':') || raw.includes('\\')) {
    return fallback;
  }
  return raw;
}
